export default {
  cscName: 'CSC Name',
  orderType: 'Order Type',
  orderNo: 'Order No.',
  cartonNo: 'Carton No.',
  platformOrderNo: 'Platform Order No.',
  expressTrackingNo: 'Express Tracking No.',
  sku: 'SKU',
  pe: 'PE',
  actualOrderQty: 'Actual Order Qty',
  rfidScanQty: 'RFID Scan Qty',
  gap: 'Gap',
  exceptionReason: 'Exception Reason (by Carton/EXP No.)',
  shipFrom: 'Ship From',
  shipFromName: 'Ship From Name',
  shipTo: 'Ship To',
  shipToName: 'Ship To Name',
  orderConfirmedTime: 'Order Confirmed Time',
  orderScheduledTime: 'Order Scheduled Time',
  orderPackedTime: 'Order Packed Time',
  orderCreateTime: 'Order Create Time',
  giTime: 'GI Time',
  orderUpc: 'Order UPC',
  rfidEpc: 'RFID EPC',
  epcDecodedUpc: 'EPC Decoded UPC',
  scanTime: 'Scan Time'
}
